import { Suspense, type ComponentType, type LazyExoticComponent } from 'react';

function PageLoading() {
  return (
    <div className="flex items-center justify-center py-24">
      <div className="w-7 h-7 border-[2.5px] border-primary-500/30 border-t-primary-500 rounded-full animate-spin" />
    </div>
  );
}

interface LazyPageProps {
  component: LazyExoticComponent<ComponentType<Record<string, never>>>;
}

export default function LazyPage({ component: Component }: LazyPageProps) {
  return (
    <Suspense fallback={<PageLoading />}>
      <Component />
    </Suspense>
  );
}